
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "../lib/data";

export const Portfolio = () => {
    const prefix = "//";
    return (
        <section id="work" data-testid="portfolio-section" className="relative py-24 md:py-32 bg-[#060c1c]">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
                    <div className="max-w-2xl">
                        <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
                            {prefix} Selected Work
                        </div>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
                            Real businesses.{" "}
                            <span className="text-gradient-cyan">Real results.</span>
                        </h2>
                    </div>
                    <p className="text-slate-400 max-w-md text-[15px] leading-relaxed">
                        A glimpse of recent premium websites I've crafted for local businesses. Each built with
                        performance, accessibility, and conversion in mind.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-2 gap-5 lg:auto-rows-[260px]">
                    {PORTFOLIO.map((p, i) => (
                        <motion.a
                            key={p.id}
                            data-testid={`portfolio-card-${p.id}`}
                            href={p.urllink}
                            // onClick={(e) => e.preventDefault()}
                            target={"_blank"}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className={`group relative ${p.span} rounded-2xl overflow-hidden border border-white/5 hover:border-cyan-400/50 transition-all bg-[#0a1024]`}
                        >

                            <img
                                src={p.image}
                                alt={p.name}
                                className="absolute top-0 inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
                            />

                            {/* <div className="absolute inset-0 bg-gradient-to-t from-[#040814] via-[#040814]/70 to-transparent" /> */}

                            <div className="relative h-full flex flex-col justify-between  min-h-[560px]">
                                <div className="flex items-start justify-between">
                                    {/* <span className="text-[10px] uppercase tracking-[0.2em] font-bold bg-background text-cyan-400 px-2.5 py-1 rounded-full border border-cyan-400/30 bg-cyan-400/5 backdrop-blur">
                                        {p.type}
                                    </span><a
                                        href={p.urllink}
                                        target="_blank" rel="noreferrer" className="relative z-10"
                                    >
                                        <div className="w-10 h-10 rounded-full glass flex items-center justify-center group-hover:bg-cyan-400 group-hover:text-[#040814] transition-colors">

                                            <ArrowUpRight size={16} />
                                        </div></a> */}
                                </div>

                                <div className="bg-background p-6 rounded-tl-2xl rounded-tr-2xl border-t border-white/5 relative z-10"  >
                                    <div className="flex items-start justify-between">
                                        <span className="text-[10px] uppercase tracking-[0.2em] font-bold bg-background text-cyan-400 px-2.5 py-1 rounded-full border border-cyan-400/30 bg-cyan-400/5 backdrop-blur">
                                            {p.type}
                                        </span><a
                                            href={p.urllink}
                                            target="_blank" rel="noreferrer" className="relative z-10"
                                        >
                                            <div className="w-10 h-10 rounded-full glass flex items-center justify-center group-hover:bg-cyan-400 group-hover:text-[#040814] transition-colors">

                                                <ArrowUpRight size={16} />
                                            </div></a>
                                    </div>
                                    <h3 className="text-2xl md:text-3xl font-bold tracking-tight mb-2">
                                        {p.name}
                                    </h3>
                                    <p className="text-slate-400 text-sm leading-relaxed mb-4 line-clamp-2">
                                        {p.location}
                                    </p>
                                    <div className="flex flex-wrap gap-2">
                                        {p.tags.map((t) => (
                                            <span
                                                key={t}
                                                className="text-xs text-slate-300 px-2.5 py-1 rounded-md bg-white/5 border border-white/5"
                                            >
                                                {t}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};
